import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-upArrow",
  "use": "icon-upArrow-usage",
  "viewBox": "0 0 18 11",
  "content": "<symbol viewBox=\"0 0 18 11\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-upArrow\">\n    <path d=\"M15.3325 10.1178L17.2353 8.24818L9.08026 0.235353L0.925237 8.24818L2.82808 10.1178L9.08026 3.97467L15.3325 10.1178Z\" fill=\"#82889C\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol